import { CalendarClock, ChevronRight, HandCoins } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { IconeTile } from '@/components/ui/cores';
import { PageHeader } from '@/components/ui/page-header';

const RELATORIOS = [
  {
    href: `seguros-vencendo/${new Date().getFullYear()}`,
    titulo: 'Seguros vencendo',
    descricao: 'Vencimentos por mês, com os que ainda não foram renovados.',
    icon: <CalendarClock />,
    cor: 'bg-amber-500/10 text-amber-600 dark:text-amber-400',
  },
  {
    href: 'comissoes',
    titulo: 'Comissões',
    descricao: 'Comissão prevista por mês e por seguradora.',
    icon: <HandCoins />,
    cor: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400',
  },
];

const RelatoriosPage: React.FC = () => (
  <div className="space-y-6">
    <PageHeader title="Relatórios" />
    <div className="grid gap-4 sm:grid-cols-2">
      {RELATORIOS.map(relatorio => (
        <Link key={relatorio.href} to={relatorio.href} className="group rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
          <Card className="flex h-full items-center gap-4 p-5 shadow-none transition-colors group-hover:bg-muted/40">
            <IconeTile cor={relatorio.cor}>{relatorio.icon}</IconeTile>
            <div className="min-w-0 flex-1">
              <h2 className="font-medium">{relatorio.titulo}</h2>
              <p className="text-sm text-muted-foreground">{relatorio.descricao}</p>
            </div>
            <ChevronRight className="h-4 w-4 text-muted-foreground transition-transform group-hover:translate-x-0.5" />
          </Card>
        </Link>
      ))}
    </div>
  </div>
);

export default RelatoriosPage;
